import type { Cart, CartItemQuantityInfo } from '@/js/types/cart.ts';
import { makeLocalizedStoreApiRoute, makeRequest } from '@/js/api/request-service.ts';

export async function getCart() {
  return makeRequest<Cart>({
    url: makeLocalizedStoreApiRoute('cart'),
  });
}

export async function updateCartItemQuantity(id: number, quantity: number) {
  return makeRequest<Cart>({
    method: 'PUT',
    url: makeLocalizedStoreApiRoute(`cart/item/${id}/update-quantity`),
    data: {
      quantity,
    },
  });
}

export async function addCartItem(productId: number, quantity: number) {
  return makeRequest<Cart>({
    method: 'POST',
    url: makeLocalizedStoreApiRoute('cart/item'),
    data: {
      productId,
      quantity,
    },
  });
}

export async function getCartItemByProductId(
  productId: number,
): Promise<CartItemQuantityInfo | null> {
  const response = await getCart();
  const items = response.data?.items;
  if (!items || items.length === 0) {
    return null;
  }

  const found = items.find(
    item => item.productId === productId,
  );

  if (!found) {
    return null;
  }

  return {
    productId: found.productId,
    quantity: found.quantity,
    maxQuantity: found.maxQuantity,
  };
}
